import { CommonModule } from "@angular/common";
import { Component, Input, Output, EventEmitter } from "@angular/core";

import { StatsCardComponent } from "@shared/components/stats-card/stats-card.component";
import {
  LastUpdate,
  LastUpdateCardComponent,
} from "@shared/components/last-update-card/last-update-card.component";
import {
  Draft,
  DraftCardComponent,
} from "@shared/components/draft-card/draft-card.component";
import { CarouselComponent } from "@shared/components/carousel/carousel.component";

export interface CatalogDashboardStats {
  label: string;
  value: string | number;
  variant?: "primary" | "golden";
}

@Component({
  selector: "app-catalog-dashboard",
  imports: [
    CommonModule,
    StatsCardComponent,
    LastUpdateCardComponent,
    DraftCardComponent,
    CarouselComponent,
  ],
  templateUrl: "./catalog-dashboard.component.html",
  styleUrl: "./catalog-dashboard.component.scss",
})
export class CatalogDashboardComponent {
  @Input() stats: CatalogDashboardStats[] = [];
  @Input() lastUpdates: LastUpdate[] = [];
  @Input() drafts: Draft[] = [];
  @Input() statsTitle: string = "Stats";
  @Input() entity: string = "client";
  @Input() lastUpdatesTitle: string = "Last Updates";
  @Input() draftsTitle: string = "Drafts";

  @Output() draftContinue = new EventEmitter<string>();

  handleContinueDraft(draftId: string): void {
    this.draftContinue.emit(draftId);
  }
}
